import {
  Container,
  IconButton,
  Tooltip
} from '@material-ui/core';

import Snackbar from '@material-ui/core/Snackbar';
import { makeStyles } from '@material-ui/core/styles';
import DeleteSweepIcon from '@material-ui/icons/DeleteSweep';
import EditIcon from '@material-ui/icons/Edit';
import ErrorIcon from '@material-ui/icons/Error';
import SendIcon from '@material-ui/icons/Send';
import MuiAlert, { AlertProps } from '@material-ui/lab/Alert';
import { useQuery } from '@tanstack/react-query';
import { useEffect, useState } from 'react';
import { mapperToMaintenancePoint } from '../../app/mappers/maintenance/maintenance-point.mapper';
import { createMaintenancePointDraft } from '../../app/services/maintenance/point/create-point.apit';
import { deleteAllMaintenancePoints, deleteMaintenancePoint } from '../../app/services/maintenance/point/delete-point.api';
import { getDraftMaintenancePointByUser } from '../../app/services/maintenance/point/get-point.api';
import { processMaintenancePoint } from '../../app/services/maintenance/point/process-point.api';
import { updateMaintenancePoint } from '../../app/services/maintenance/point/update-point.api';
import DialogSearch from '../../common/components/DialogSearch';
import EnhancedTable, { HeadCell } from '../../common/components/EnhancedTable';
import { handleCheckPrevValue } from '../../common/functions/checkPrevValue';
import MaintenancePointDialog from './MaintenancePointDialog';
import MaintenancePointDrawer from './MaintenancePointDrawer';
import MaintenancePointHeader from './MaintenancePointHeader';
import { customtheme } from '../../app/theme/theme';
import { useLocation } from 'react-router-dom';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: customtheme.gray[200],
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
  },
  tableSection: {
    padding: theme.spacing(4),
    flex: 1,
    display: 'flex',
  },
  tableSectionContainer: {
    padding: 0, 
    flex: 1,
    display: 'flex', 
    flexDirection: 'column',
    maxWidth: '100%',
  },
  appbar: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    background: customtheme.white,
    color: customtheme.black,
    padding: theme.spacing(2),
    margin: 1,
  },  
  scrollableTabs: {
    overflowX: 'auto',
  },
}));

interface DialogSearchData {
  id: string;
  title: string;
  key: string;
  keySub: string;
  isPrevSearch?: boolean;
  prevSearch?: any;
  prevDataSearch: any;
}

const MaintenancePoint = () => {
  const classes = useStyles();
  const location = useLocation();

  const windowHeight = window.innerHeight;
  const headerHeight = 500; // Altura do cabeçalho em pixels
  const footerHeight = 48; // Altura do rodapé em pixels
  const itemHeight = 80; // Altura média de cada item em pixels
  const availableHeight = windowHeight - headerHeight - footerHeight;
  const itemsPerPage = Math.floor((availableHeight) / itemHeight)

  const [selectedData, setSelectedData] = useState<any>([]);
  const [orderBy, setOrderBy] = useState<string>('nomrep');
  const [selected, setSelected] = useState<string[]>([]);
  const [page, setPage] = useState(0);
  const [count, setCount] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(itemsPerPage > 5 ? itemsPerPage : 5);
  const [isDrawerOpen, setIsDrawerOpen] = useState({open: location.state ? true : false, btnTitle: 'Salvar', btnType: 'save'});
  const [isDialogSearchOpen, setIsDialogSearchOpen] = useState(false);
  const [isDialogFeedbackOpen, setIsDialogFeedbackOpen] = useState({open:false, message: '', title: '', btnType: ''});
  const [isSnackbar, setIsSnackbar] = useState({open:false, message: 'info', title: ''});
  const [isLoading, setIsLoading] = useState(false);
  const [dialogDataSearch, setDialogDataSearch] = useState<DialogSearchData | null>(null);
  const [checkPrevCompanyValue, setCheckPrevCompanyValue] = useState({
    exists: location.state ? true : false,
    value: location.state ? location.state.find((state: any) => state.id === 'dados').value.codemp : ''
  })
  const [checkPrevMaintenanceValue, setCheckPrevMaintenanceValue] = useState({
    exists: location.state ? true : false,
    value: location.state ? location.state.find((state: any) => state.id === 'manutencao').value.nummnt : ''
  })
  const [checkPrevIntershipValue, setCheckPrevIntershipValue] = useState({
    exists: false,
    value: ''
  })
  
  const fieldsInit = mapperToMaintenancePoint({})

  const [fields, setFields] = useState<any[]>(location.state ? location.state : fieldsInit)
  const headCells: HeadCell[] = [
    { id: 'codemp', numeric: true, disablePadding: false, label: 'Código Empresa' },
    { id: 'nomemp', numeric: false, disablePadding: true, label: 'Empresa' },
    { id: 'codeqp', numeric: false, disablePadding: true, label: 'Código Equipamento' },
    { id: 'deseqp', numeric: false, disablePadding: true, label: 'Equipamento' },
    { id: 'nummnt', numeric: false, disablePadding: true, label: 'Número Manutenção' },
    { id: 'numcad', numeric: false, disablePadding: true, label: 'Código Operador' },
    { id: 'descad', numeric: false, disablePadding: true, label: 'Operador' },
    { id: 'codetg', numeric: false, disablePadding: true, label: 'Código Estágio' },
    { id: 'desetg', numeric: false, disablePadding: true, label: 'Estágio' },
    { id: 'seqrot', numeric: false, disablePadding: true, label: 'Sequência' },
    { id: 'fimoop', numeric: false, disablePadding: true, label: 'Finalizar' },
    { id: 'turtrb', numeric: false, disablePadding: true, label: 'Turno' },
    { id: 'datapt', numeric: false, disablePadding: true, label: 'Data Apontamento' },
    { id: 'horapt', numeric: false, disablePadding: true, label: 'Hora Apontamento' },
    { id: 'actions', numeric: true, disablePadding: false, label: 'Ações' },
  ];

  const createData = (props:any) => {
    const {id, codemp, nomemp, codeqp, deseqp, nummnt, numcad, descad, codetg, desetg, seqrot, fimoop, turtrb, datapt, horapt} = props
    return { id, codemp, nomemp, codeqp, deseqp, nummnt, numcad, descad, codetg, desetg, seqrot, fimoop, turtrb, datapt, horapt, ...props };
  }

  const handleOpenDrawer = () => {
    setIsDrawerOpen({open: true, btnTitle: 'Salvar', btnType: 'save'});
  };

  const handleCloseDrawer = () => {
    setSelected([])
    setFields(fieldsInit);
    setIsDrawerOpen({open: false, btnTitle: 'Salvar', btnType: 'save'});
  };

  const handleOpenDialogSearch = (data: DialogSearchData) => {
    setIsDialogSearchOpen(true);
    setDialogDataSearch(data);
  };

  const handleCloseDialogSearch = () => {
    setIsDialogSearchOpen(false);
    setDialogDataSearch(null);
    setSelected([]);
  };

  const handleCloseSnackbar = (event?: React.SyntheticEvent, reason?: string) => {
    if (reason === 'clickaway') {
      return;
    }

    setIsSnackbar({open: false, message: '', title: 'info'});
  };

  const handleCloseErro = () => {
    setIsDialogFeedbackOpen({open:false, message: '', title: '', btnType: 'erro'});
    setSelected([])
    setFields(fieldsInit);
  }

  const handleUpdateField = (data: any) => {
    const update = [...fields];
    update[update.findIndex((field) => field.id === dialogDataSearch?.id)].value = 
      data[dialogDataSearch?.key || ''] === 'Nenhum item' ? null : data
    setFields(update)
    setIsDialogSearchOpen(false);
    setDialogDataSearch(null);
    if(dialogDataSearch?.id === 'dados')
      setCheckPrevCompanyValue(handleCheckPrevValue('dados', update, 'codemp'))
    if(dialogDataSearch?.id === 'manutencao')
      setCheckPrevMaintenanceValue(handleCheckPrevValue('manutencao', update, 'nummnt'))
    if(dialogDataSearch?.id === 'estagio')
      setCheckPrevIntershipValue(handleCheckPrevValue('estagio', update, 'codetg'))
  }

  const { isFetching, refetch } = useQuery(['maintenancePoint'], async () => {
    // obtem as requisicao rascunho
    const token = localStorage.getItem('token')
    if(token){
      const res = await getDraftMaintenancePointByUser(token, {
        take: rowsPerPage,
        skip: page*rowsPerPage,
      })
      if(res){
        setSelectedData(res.results)
        setCount(res.total)
      }
    }
    return []
  }, {
    refetchOnWindowFocus: false,
  })
  
  useEffect(() => {
    refetch();
  }, [page, refetch]);

  const Alert = (props: AlertProps) => {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
  }

  const handleFormatedDataToDatabase = async (btnType: string) => {
    setIsLoading(true)
    
    let data = {
      codemp: checkPrevCompanyValue.value,
      nomemp: fields.filter((field) => field.id === 'dados')[0].value?.nomemp,
      codeqp: fields.filter((field) => field.id === 'equip')[0].value?.codeqp,
      deseqp: fields.filter((field) => field.id === 'equip')[0].value?.deseqp,
      obsapt: fields.filter((field) => field.id === 'obsapt')[0].value?.obsapt,
      nummnt: fields.filter((field) => field.id === 'manutencao')[0].value?.nummnt + '',
      datapt: fields.filter((field) => field.id === 'datapt')[0].value?.datapt.split('T')[0],
      horapt: fields.filter((field) => field.id === 'datapt')[0].value?.datapt.split('T')[1],
      numcad: fields.filter((field) => field.id === 'operador')[0].value?.numcad + '',
      descad: fields.filter((field) => field.id === 'operador')[0].value?.nomope,
      codetg: fields.filter((field) => field.id === 'estagio')[0].value?.codetg + '',
      desetg: fields.filter((field) => field.id === 'estagio')[0].value?.desetg,
      turtrb: fields.filter((field) => field.id === 'turtrb')[0].value?.turtrb,
      seqrot: fields.filter((field) => field.id === 'sequencia')[0].value?.seqrot + '',
      fimoop: fields.filter((field) => field.id === 'fimoop')[0].value?.fimoop,
    }
    
    const useCaseSuccess = {
      save: 'criar apontamento manutenção',
      edit: 'editar apontamento manutenção',
      remove: 'remover apontamento manutenção',
      removeAll: `remover apontament${selected.length > 1 ? 'os': 'o'} manutenção`,
      proccess: `processar apontament${selected.length > 1 ? 'os': 'o'} manutenção`
    } as any

    const token = localStorage.getItem('token')
    let res = {
      statusCode: 400,
    } as any
    
    if(token){
      if(btnType === 'save')
        res = await createMaintenancePointDraft(data, token)
        if(btnType === 'edit' && selected.length > 0)
          res = await updateMaintenancePoint(selected[0], data, token)
        if(btnType === 'remove' && selected.length > 0)
          res = await deleteMaintenancePoint(selected[0], token)
        if(btnType === 'removeAll' && selected.length > 0)
            res = await deleteAllMaintenancePoints(selected, token)
        if(btnType === 'proccess' && selected.length > 0)
          res = await processMaintenancePoint(selected, token)
      
      setIsLoading(false)
      if(res.statusCode === 200){
        setIsSnackbar({
          open: true,
          message: `Sucesso ao ${useCaseSuccess[btnType]}`,
          title: 'success'
        })
      } else {
        setIsSnackbar({
          open: true,
          message: `Erro ao ${useCaseSuccess[btnType]}`,
          title: 'error'
        })
      }
      refetch()
      setIsDialogFeedbackOpen({
        open: false,
        message: '',
        title: '',
        btnType,
      })
      setIsDrawerOpen({
        open: false,
        btnTitle: '',
        btnType: '',
      })
      setFields(fieldsInit)
      setSelected([])
    } else {
      setIsSnackbar({
        open: true,
        message: `Erro ao ${useCaseSuccess[btnType]}`,
        title: 'error'
      })
    }
  } 


  const handleRemoveAll = () => {
    handleDialogConfirmation('removeAll') 
  }

  const handleProcess = () => {
    handleDialogConfirmation('proccess') 
  }

  const handleRemove = (id:any) => {
    handleDialogConfirmation('remove')
  }
  
  const handleErro = (id:any) => {
    setIsDialogFeedbackOpen({
      open: true,
      message: selectedData.filter((data:any) => data.id === id)[0].msgerro,
      title: 'Erro Erp',
      btnType: 'erro'
    })
  }

  const handleEdit = (id:any) => {
    const item = selectedData.filter((data:any) => data.id === id )
    
    setCheckPrevCompanyValue({
      value: item[0].codemp,
      exists: true,
    })

    setCheckPrevMaintenanceValue({
      value: item[0].nummnt,
      exists: true,
    })
    setCheckPrevIntershipValue({
      value: item[0].codetg,
      exists: true,
    })

    setFields(mapperToMaintenancePoint(item[0]))
    setIsDrawerOpen({open: true, btnTitle: 'Editar', btnType: 'edit'});
  }

  const handleCheckFields = () => {
    const requireds = fields.filter((field) => field.required)
    if(requireds.length !== requireds.filter((required) => required.value).length) {
      setIsSnackbar({open:true, message: 'Por favor, adicione os campos obrigatórios!', title: 'error'})
    } else { 
      handleDialogConfirmation(isDrawerOpen.btnType)
    }
  }
  
  const handleDialogConfirmation = (type: string) => {
    const useCaseFeedbackTitle = {
      save: 'Deseja criar apontamento de manutenção',
      edit: 'Deseja editar um apontamento de manutenção',
      remove: 'Deseja remover um apontamento de manutenção',
      removeAll: 'Deseja remover os apontamentos de manutenção selecionadas',
      proccess: `Deseja processar o${selected.length > 1 ? 's apontamentos' : ' apontamento'} de manutenção`
    } as any

    setIsDialogFeedbackOpen({
      open: true,
      title: useCaseFeedbackTitle[type],
      message: '',
      btnType: type,
    })
  }

  const handleCheckError = () => {
    const itemSelected = selectedData.filter((data:any) => data.id === selected[0])
    if(itemSelected){
      const erro =  Object.entries(itemSelected[0]).find(([key, val]) => key.includes('erro'))
      if(erro && erro[1] !== null)
        return true
      else
        return false
    }
    return false
  }
  return (
    <div className={classes.root}>
      <MaintenancePointHeader
        onClick={handleOpenDrawer}
      />
      <div className={classes.tableSection}>
        <Container className={classes.tableSectionContainer}>
          <EnhancedTable 
            title='Apontamentos'
            rowsPerPageOptions={[]}
            isClickable={true}
            data={selectedData?.map((data:any) => createData(data) )}
            count={count}
            orderBy={orderBy}
            setOrderBy={setOrderBy}
            headCells={headCells}
            isLoading={isFetching}
            selected={selected}
            setSelected={setSelected}
            page={page}
            setPage={setPage}
            rowsPerPage={rowsPerPage}
            setRowsPerPage={setRowsPerPage}
            buttonsSelected={[
              selected.length === 1 && 
              <Tooltip 
                title="Editar"
                onClick={() => handleEdit(`${selected[0]}`)}
                key='edit'
              >
                <IconButton aria-label="edit">
                  <EditIcon style={{color: customtheme.white}}/>
                </IconButton>
              </Tooltip>,
            (selected.length === 1 && handleCheckError()) && 
              <Tooltip
                title="Erro"
                onClick={() => handleErro(`${selected[0]}`)}
                key='erro'
              >
              <IconButton aria-label="erro">
                <ErrorIcon style={{color: customtheme.white}}/>
              </IconButton>
            </Tooltip>,
              <Tooltip title="Deletar" onClick={handleRemoveAll} key='deleteall'>
                <IconButton aria-label="delete">
                  <DeleteSweepIcon style={{color: customtheme.white}}/>
                </IconButton>
              </Tooltip>,
              <Tooltip title="Processar" onClick={handleProcess} key='process'>
                <IconButton aria-label="processar">
                  <SendIcon style={{color: customtheme.white}}/>
                </IconButton>
              </Tooltip>,
            ]}
            buttonsActions={['edit', 'erro', 'remove']}
            handleEdit={handleEdit}
            handleErro={handleErro}
            handleRemove={handleRemove}
          />
        </Container>
      </div>
      <MaintenancePointDrawer
        checkPrevCompanyValue={checkPrevCompanyValue}
        checkPrevIntershipValue={checkPrevIntershipValue}
        checkPrevMaintenanceValue={checkPrevMaintenanceValue}
        fields={fields}
        handleCheckFields={handleCheckFields}
        handleCloseDrawer={handleCloseDrawer}
        handleCloseSnackbar={handleCloseSnackbar}
        handleOpenDialogSearch={handleOpenDialogSearch}
        isDrawerOpen={isDrawerOpen}
        setFields={setFields}
      />  
      <DialogSearch
        title={dialogDataSearch?.title || ''}
        id={dialogDataSearch?.id || ''}
        keyItem={dialogDataSearch?.key || ''}
        keySubItem={dialogDataSearch?.keySub || ''}
        isDialogOpen={isDialogSearchOpen}
        isPrevSearch={dialogDataSearch?.isPrevSearch || false}
        prevSearch={dialogDataSearch?.prevSearch || []}
        prevDataSearch={dialogDataSearch?.prevDataSearch}
        handleCloseDialog={handleCloseDialogSearch}
        handleUpdateField={(data:any) => { handleUpdateField(data) }}
      />
      <MaintenancePointDialog
        handleCloseErro={handleCloseErro}
        handleFormatedDataToDatabase={handleFormatedDataToDatabase}
        isDialogFeedbackOpen={isDialogFeedbackOpen}
        isLoading={isLoading}
      />
      <Snackbar open={isSnackbar.open} autoHideDuration={3000} onClose={handleCloseSnackbar}>
        <Alert onClose={handleCloseSnackbar} severity={isSnackbar.title as any}>
          {isSnackbar.message}
        </Alert>
      </Snackbar>
    </div>
  );
};

export default MaintenancePoint;